import { useCallback } from 'react';

export const useBatchedHandlers = (handlers: (Function | undefined)[]) =>
    useCallback(
        (...args: any[]) => {
            handlers.forEach((handler) => {
                if (handler) {
                    handler(...args);
                }
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [...handlers]
    );
